import { createPinia } from "pinia";
import { createApp } from "vue";

import App from "@/App.vue";
import { router } from "@/router";
import { useAuthStore } from "@/stores/auth";

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);
app.use(router);

const auth = useAuthStore();
auth.installInterceptors();

async function bootstrap(): Promise<void> {
  try {
    await auth.hydrate();
  } catch (err) {
    console.warn("auth.hydrate failed", err);
  }
  await router.isReady();
  app.mount("#app");
}

void bootstrap();
